import { InjectionToken } from '@angular/core';

import {
  type IChartsConfig,
  type IDonutConfig,
  type IGraphConfig,
  type IGroupedBarLineChartConfig,
  type ILegendConfig,
  type ILineChartConfig,
  type IStackedBarChartConfig,
  type IStackedLineChartConfig,
} from '../charts.interface';

export const CHARTS_CONFIG = new InjectionToken('ChartsConfig');
export const CHARTS_USER_CONFIG = new InjectionToken('ChartsUserConfig');

export class ChartsConfig implements IChartsConfig {
  public donut: IDonutConfig = {
    outerRadius: 130,
    innerRadius: 80,
    width: 560,
    tooltip: {
      boxWidth: 128,
      boxHeight: 80,
      arrowWidth: 8,
      arrowHeight: 16,
    },
  };

  public legend: ILegendConfig = {
    minimizedNumberToShow: 8,
  };

  public graph: IGraphConfig = {
    height: 360,
    yTickCount: 6,
    gridlines: {
      horizontal: true,
      vertical: false,
    },
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 50,
    paddingRight: 0,
  };

  public stackedBarChart: IStackedBarChartConfig = {
    maxBarWidth: 80,
    tooltip: {
      boxWidth: 128,
      boxHeight: 70,
      arrowWidth: 16,
      arrowHeight: 8,
    },
  };

  public lineChart: ILineChartConfig = {
    lineOpacity: 1,
    fillOpacity: 0.6,
  };

  public stackedLineChart: IStackedLineChartConfig = {
    tooltipWidth: 210,
  };

  public groupedBarLineChart: IGroupedBarLineChartConfig = {
    ...this.graph,
    ...this.stackedBarChart,
    ...this.lineChart,
    ...this.stackedLineChart,
  };
}

export const CHARTS_CONFIG_PROVIDER = {
  provide: CHARTS_CONFIG,
  useValue: new ChartsConfig(),
};
